import { CALL_SELECTED } from './conferenceDetailActions';

export default (previousState = {}, { type, payload }) => {
  if (type === CALL_SELECTED) {
    return payload.callId;
  }
  return previousState;
}



// WEBPACK FOOTER //
// ./src/pages/ConferenceDetail/conferenceDetailReducer.js